import { inject } from '@angular/core';
import { CanActivateFn, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { AuthService } from '@core';
import { environment } from '../../../../environments/environment';
import { Observable } from 'rxjs';

// The updated AzureB2CAuthGuard using CanActivateFn
export const AzureB2CAuthGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree => {
  // Inject AuthService using the inject() function
  const authService = inject(AuthService);

  const fragment = route.fragment;
  
  if (fragment) {
    const token = new URLSearchParams(fragment).get('id_token');
    const errorDescription = new URLSearchParams(fragment).get('error_description');
    
    if (token) {
      // Handle token
      authService.login(token);
      return true;
    } else {
      if (errorDescription?.split(':').includes('AADB2C90118')) {
        // User forgot password flow
        resetPass();
      } else {
        login();
      }
      return false;
    }
  } else {
    if (authService.isAuthorizedByAzureB2c) {
      return true;
    } else {
      login();
      return false;
    }
  }
};

// Reset password logic
function resetPass(): void {
  window.location.replace(environment.b2cForgotPassFlow);
}

// Login flow
function login(): void {
  window.location.replace(environment.b2cSignInSignUpFlow);
}
